export default (value, one, twoThreeFour, many) => {
  if (1 === value) {
    return one;
  }

  if ([12, 13, 14].includes(value)) {
    return many;
  }

  const modulo10 = value % 10;

  if (0 === modulo10) {
    return many;
  }

  if ([2, 3, 4].includes(modulo10)) {
    return twoThreeFour;
  }

  return many;
};
